import { render, staticRenderFns } from "./AnomalyConfirmDialog.vue?vue&type=template&id=2bb60c1b&scoped=true"
import script from "./AnomalyConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AnomalyConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AnomalyConfirmDialog.vue?vue&type=style&index=0&id=2bb60c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb60c1b",
  null
  
)

export default component.exports